<script>
export default {
    name: 'ForgotPassword',
    components: {}
}
</script>

<template>
    <b-container>
        <b-row>
            <b-col lg="6" offset-lg="3" class="mt-5">
                <b-card header="Página No Encontrada">
                    Lo sentimos, la página que estás buscando no se puede encontrar.
                    <template #footer>
                        <b-button size="sm" variant="secondary" :to="{ name: 'dashboard' }">Volver a Inicio</b-button>
                    </template>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>